import angular from 'angular';

angular.module('myConsultApp').directive('elementReady', function ($timeout, $rootScope) {
  return {
    restrict: 'A',
    link: function ($scope, element, attrs) {
      $timeout(() => {
        element.ready(() => {
          $scope.$apply(() => {
            $rootScope.$broadcast(`${attrs.elementReady}:ready`);
          });
        });
      });
    },
  };
});
